import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class StockAvailibilityService {

    private api_url_get_warehouses = './api/switch_site/server.php?cmd=GET_WAREHOUSE';
    private api_url_get_stock_availibility = './api/server.php?cmd=GET_STOCK_AVAILIBILITY';
    private api_url_get_details_by_article = './api/server.php?cmd=GET_DETAILS_BY_ARTICLE';
    private api_url_get_mvt_by_art_warehouse = './api/server.php?cmd=GET_MVT_BY_ART_WAREHOUSE';

    private api_url_get_stock_status_from_the_other_sites = './api/server.php?cmd=GET_STOCK_STATUS_FROM_THE_OTHER_SITES';

    constructor(private http: Http) {}

    getWarehouses(): Promise<Object> {
        return this.http.get(this.api_url_get_warehouses)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getStockAvailibility(mode: string): Promise<Object[]> {
        return this.http.get(this.api_url_get_stock_availibility
            + '&mode=' + mode
        )
            .toPromise()
            .then(response => response.json() as Object[])
            .catch(this.handleError);
    }

    getDetailsByItem(name: string, warehouse: any): Promise<Object[]> {
        return this.http.get(this.api_url_get_details_by_article
            + '&name=' + name
            + '&warehouse=' + warehouse
        )
            .toPromise()
            .then(response => response.json() as Object[])
            .catch(this.handleError);
    }

    detailsMouvementWarehouse(name: string, warehouses: any): Promise<Object[]> {
        return this.http.get(this.api_url_get_mvt_by_art_warehouse
            + '&name=' + name
            + '&warehouses=' + warehouses
        )
            .toPromise()
            .then(response => response.json() as Object[])
            .catch(this.handleError);
    }

    ShowStockStatusFromOtherSites(internal_code: any): Promise<Object[]> {
        return this.http.get(this.api_url_get_stock_status_from_the_other_sites
            + '&internal_code=' + internal_code
        )
            .toPromise()
            .then(response => response.json() as Object[])
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/stock-availibility.service.ts